import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { Immobile } from '../../../../models';

@Component({
  selector: 'app-dialog-immobile-cancellazione-logica',
  templateUrl: './dialog-immobile-cancellazione-logica.component.html',
  styleUrls: ['./dialog-immobile-cancellazione-logica.component.css']
})
export class DialogImmobileCancellazioneLogica implements OnInit {
  immobile: Immobile;

  constructor(public dialogRef: MatDialogRef<DialogImmobileCancellazioneLogica>,
    @Inject(MAT_DIALOG_DATA) public data: Immobile) 
  {
    this.immobile = data;
  }

  ngOnInit() {}

  si(){
    this.dialogRef.close(true);
  }

}


// WEBPACK FOOTER //
// /home/david/vscode-workspace/TOP-casa-nel-web/frontend/src/app/components/utilita/dialogs/dialog-immobile-cancellazione-logica/dialog-immobile-cancellazione-logica.component.ts